import React from "react";
import { useLocation, Route, Switch, Redirect } from "react-router-dom";
import { useCookies } from "react-cookie";
import Sidebar from "components/Sidebar/Sidebar.js";
import routes from "routes.js";

function Admin() {
  const location = useLocation();
  const [cookies] = useCookies(["userToken", "userRole"]);
  const mainContentRef = React.useRef(null);
  React.useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    mainContentRef.current.scrollTop = 0;
  }, [location]);

  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.layout.includes("admin")) {
        return (
          <Route
            exact={prop.exact}
            path={prop.layout + prop.path}
            component={prop.component}
            key={key}
          />
        );
      } else {
        return null;
      }
    });
  };

  const adminRoutes = routes.filter((route) => route.layout === "/admin");

  if (!cookies.userToken || cookies.userRole !== "admin") {
    return <Redirect to="/" />;
  }

  return (
    <>
      <Sidebar routes={adminRoutes} />
      <div
        // className="main-content"
        ref={mainContentRef}
        style={{ marginLeft: "250px", width: "calc(100vw-250px)" }}
      >
        <Switch>
          {getRoutes(routes)}
          <Redirect from="*" to="/admin/companies" />
        </Switch>
      </div>
    </>
  );
}

export default Admin;
